module.exports = __webpack_public_path__ + "static/media/signage-outdoor-img4.2c01e64c.jpg";